import { PrimaryButton, SecondaryButton, Typography } from '@weareopenr/component-library';
import { useForm } from 'react-hook-form';
import { ButtonContainer } from 'src/components/ButtonContainer/ButtonContainer';
import { usePriceSchemes } from 'src/hooks/usePriceSchemes';
import { PriceSchemeNameInput } from '../../PriceSchemeNameInput';
import styles from './DuplicateSchemeStep.module.scss';

type Props = {
  schemeId: string;
  submitting: boolean;
  cancelText: string;
  onCancel: () => void;
  onSubmit: (t: TDuplicatePriceSchemeSchema) => void;
};

type TDuplicatePriceSchemeSchema = {
  schemeId: string;
  name: string | undefined;
};

const DuplicateSchemeStep = ({ schemeId, onCancel, onSubmit, cancelText, submitting }: Props) => {
  const formFields = useForm<{ name: string | undefined }>({
    defaultValues: { name: undefined },
  });
  const { formState, handleSubmit, watch } = formFields;
  const { data = [] } = usePriceSchemes();

  const sourceName = data.find((scheme) => scheme.id === schemeId)?.name;

  const submitForm = ({ name }: { name: string | undefined }) => onSubmit({ schemeId, name });

  const { name } = watch();

  return (
    <form onSubmit={handleSubmit(submitForm)} className={styles.form}>
      {sourceName && (
        <Typography size="medium" weight="regular">
          Price Scheme: <strong>{sourceName}</strong>
        </Typography>
      )}
      <PriceSchemeNameInput formFields={formFields} />
      <ButtonContainer
        left={
          <SecondaryButton data-cy="cancel-button" buttonStyle="outline" onClick={onCancel} size="full-width">
            {cancelText}
          </SecondaryButton>
        }
        right={
          <PrimaryButton
            data-cy="create-button"
            disabled={!formState.isDirty || !name?.length}
            loading={submitting}
            size="full-width"
            type="submit"
          >
            Create
          </PrimaryButton>
        }
      />
    </form>
  );
};

export default DuplicateSchemeStep;
